import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ViewRequestedListingService {
    
    constructor(private _http: HttpClient) { }

    viewrequestedlisting(data) {
        return this._http.post(environment.api_url+'admin/product/requirement/details',data);
    }

    deleterequestedlisting(data) {
        return this._http.post(environment.api_url+'admin/product/requirement/delete',data);
    }

    startrequestedlisting(data) {
        return this._http.post(environment.api_url+'admin/product/requirement/confirm',data);
    }

}
